<template lang="pug">
v-container(fluid class="tw-min-h-screen tw-bg-blueGray-50 tw-py-10")
  v-container(class="tw-max-w-4xl")
    v-row(justify="space-between" align="center" class="tw-mb-10")
      v-col(cols="auto")
        router-link(to="/" aria-label="Kubiqa home")
          v-img(src="@/assets/images/kubiqa-logo.svg" width="150px")
      v-col(cols="auto")
        v-btn(text color="#2f53c9" to="/") Back to Kubiqa
    v-card(flat class="tw-bg-white tw-rounded-lg tw-p-6 md:tw-p-12")
      article(class="legal-page")
        h1 Privacy Policy
        p(class="legal-page__updated") Last updated: September 13, 2026

        h2 Who we are
        p Kubiqa is operated by PLOP Corp, a Delaware corporation ("PLOP Corp," "we," "us," or "our"). This Privacy Policy explains how we handle information when you use Kubiqa.

        h2 Information we handle
        p We handle information you provide when creating or using an account, including your name, email address, company details, and support communications. We also handle customer-provided property-management data that you enter or upload to use Kubiqa, such as property, listing, contact, and activity information.

        h2 How we use information
        p We use this information to provide, secure, maintain, and improve Kubiqa; to authenticate users and support their accounts; to respond to requests; and to comply with applicable law.

        h2 Cookies and analytics
        p Kubiqa uses essential authentication and session cookies so that sign-in and account access work securely. Where Google Analytics is configured for a Kubiqa environment, it helps us understand aggregate use of the service. You can control cookies through your browser settings, although disabling essential cookies may prevent parts of Kubiqa from working.

        h2 Service providers and integrations
        p We use service providers to operate Kubiqa, such as hosting, email, and analytics providers. We process information through a configured email or other vendor integration only when that integration is used for your Kubiqa account or service request. We do not sell personal information.

        h2 Your choices
        p You may request access to, correction of, or deletion of your personal information by contacting us. We may need to retain certain information where required or permitted by law, or to protect Kubiqa and its users.

        h2 Changes and contact
        p We may update this Privacy Policy as Kubiqa changes. We will post the updated policy here with a revised date. For privacy questions or requests, contact us at
          |
          a(href="mailto:paulino@yukas.com") paulino@yukas.com.
</template>

<script>
export default {
  name: 'Privacy',
};
</script>

<style scoped lang="scss">
.legal-page {
  color: #344054;
  font-size: 1rem;
  line-height: 1.7;
}

.legal-page h1,
.legal-page h2 {
  color: #1d2939;
}

.legal-page h1 {
  font-size: 2.25rem;
  margin-bottom: 0.25rem;
}

.legal-page h2 {
  font-size: 1.25rem;
  margin: 2rem 0 0.5rem;
}

.legal-page__updated {
  color: #667085;
}

.legal-page a {
  color: #2f53c9;
}
</style>
